import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import LoginDashboard from './pages/login-dashboard';
import GovernanceEvaluation from './pages/governance-evaluation';
import AIAnalysisDashboard from './pages/ai-analysis-dashboard';
import MarketAssessment from './pages/market-assessment';
import EquipmentAnalysis from './pages/equipment-analysis';
import ActionPlanDashboard from './pages/action-plan-dashboard';
import ExecutiveReport from './pages/executive-report';
import OperationalAssessment from './pages/operational-assessment';
import DecisionMatrix from './pages/decision-matrix';
import FinancialAnalysisForm from './pages/financial-analysis-form';
import SupplierManagement from './pages/supplier-management';
import CompanyProfileForm from './pages/company-profile-form';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<LoginDashboard />} />
        <Route path="/login-dashboard" element={<LoginDashboard />} />
        <Route path="/governance-evaluation" element={<GovernanceEvaluation />} />
        <Route path="/ai-analysis-dashboard" element={<AIAnalysisDashboard />} />
        <Route path="/market-assessment" element={<MarketAssessment />} />
        <Route path="/equipment-analysis" element={<EquipmentAnalysis />} />
        <Route path="/action-plan-dashboard" element={<ActionPlanDashboard />} />
        <Route path="/executive-report" element={<ExecutiveReport />} />
        <Route path="/operational-assessment" element={<OperationalAssessment />} />
        <Route path="/decision-matrix" element={<DecisionMatrix />} />
        <Route path="/financial-analysis-form" element={<FinancialAnalysisForm />} />
        <Route path="/supplier-management" element={<SupplierManagement />} />
        <Route path="/company-profile-form" element={<CompanyProfileForm />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
